<template>
  <div>

    <ul style="display: flex;justify-content:center;" class="container foot">
      <li style="width: 500px;">
        <div class="container1" style="margin-left: 14%;">
          <span style="font-size: 40px;margin-right: 10px;">泰安市医师协会</span>
          <img width="80px" src="@/assets/logo.png" alt="" style="margin-top: 10px;">
        </div>
      </li>
      <li style="margin-left: 10px;">
        <div>
          <span> 电话：0538-6995177 / 6998889 </span>
          <span style="margin-left: 30px;">
            邮编：271000
          </span>
        </div>

        <div>
          <span> 网址：www.tamda.org.cn</span>
          <span style="margin-left: 30px;">
            邮箱：taysxh@126.com
          </span>

        </div>
        <div>
          <span>
            地址：泰安市高新区丰园路117号
          </span>
          <span style="margin-left: 30px;">
            工信部链接：https://beian.miit.gov.cn/
          </span>
        </div>

        <div style="margin-top: 10px;">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" title="鲁ICP备2023006018号-1"><span style="color: #fff">备案号： 鲁ICP备2023006018号-1 </span></a><br />
          <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt="公安备案图标" style="width: 16px; height: 16px; margin-right: 5px; vertical-align: middle;">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37091102000910" target="_blank" title="鲁公网安备37091102000910号"><span style="color: #fff">鲁公网安备37091102000910号 </span></a><br />
        </div>

      </li>

      <li style="margin-left: 50px;">
        <div>
          <img src="@/assets/skin/images/wx.jpg" alt="" width="100px" height="100px" style="display: inline-block; vertical-align: middle;">
          <div>
            <span style="display: inline-block; vertical-align: middle;">微信公众号</span>
          </div>

        </div>
      </li>
      <li style="margin-left: 30px;">
        <div>
          <img src="@/assets/skin/images/yd.jpg" alt="" width="100px" height="100px" style="margin-left: 10px;display: inline-block; vertical-align: middle;">
          <div>
            <span style="display: inline-block; vertical-align: middle;">移动端</span>
          </div>
        </div>
      </li>
    </ul>
    <!--页尾结束-->
    <!--浮动工具开始-->
    <dl class="toolbar" id="toolbar">
      <dd><a href="javascript:;" title="回到顶部"><i id="toTop" class="top"><span></span></i></a></dd>
      <dd>
        <i class="code"><span></span></i>
        <ul class="pop pop-code">
          <li>
            <img src="@/assets/skin/images/wx.jpg" />
            <h3><b>扫一扫</b>关注于我们</h3>
          </li>
        </ul>
      </dd>
      <dd @click="btnNav"><a href="javascript:void(0);" title="咨询投诉"><i class="qq"><span></span></i></a></dd>
      <!-- <dd>
        <i class="tel"><span></span></i>
        <div class="slide">
       
          <div class="fenx">
            <div id="bdshare" class="share bdsharebuttonbox bdshare-button-style0-16"> <a href="#" class="bds_weixin"
                data-cmd="weixin" title="分享到微信"></a> <a href="#" class="bds_qzone" data-cmd="qzone" title="分享到QQ空间"></a>
              <a href="#" class="bds_sqq" data-cmd="sqq" title="分享到QQ好友"></a> <a href="#" class="bds_tsina"
                data-cmd="tsina" title="分享到新浪微博"></a> </div>
          </div>
          
        </div>
      </dd> -->
      <dd><a href="javascript:;" title="回到底部"><i id="toBottom" class="bottom"><span></span></i></a></dd>
    </dl>
    <!--浮动工具结束-->
  </div>
</template>
<script>

export default {
  name: "Footer",
  data() {
    return {

    };
  },
  methods: {
    btnNav() {
      this.$router.push("/ContactUs")
    }
  }

};
</script>
<style scoped>
.container1 {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中，如果需要的话 */
}
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue